// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"assets_i18n_en_translation_json":"0c16c356e6d682175a93","assets_i18n_nl_translation_json":"c4c46371e908eb3f9adb"}[chunkId] + ".chunk.js";
};